export function idToPercentage(id: string): number {
	const parsed = parseInt(id.slice(-2), 16);
	if (Number.isNaN(parsed) || !Number.isFinite(parsed)) {
		return 0;
	}

	return Math.floor((parsed * 100) / 256);
}
